export default "__VITE_ASSET__D4T0hV63__"